<template>
  <section class="flex flex-col gap-3 sm:rounded-3xl sm:border sm:border-edge sm:bg-panel sm:p-6">
    <div class="flex items-baseline justify-between gap-2">
      <h2 class="font-display text-[22px] font-extrabold sm:text-[26px]">Treueste Hippos</h2>
      <span class="text-xs text-slate-400 sm:text-sm">von {{ meetings }} Stammtischen</span>
    </div>

    <p v-if="rows.length === 0" class="py-6 text-center text-slate-400">Noch keine Anwesenheiten erfasst.</p>

    <ol v-else class="flex flex-col gap-2 sm:gap-1">
      <li
        v-for="(row, index) in rows"
        :key="row.name"
        class="flex items-center gap-3 rounded-2xl border border-edge bg-panel px-3 py-2.5 sm:rounded-none sm:border-0 sm:bg-transparent sm:px-0 sm:py-1.5"
      >
        <span class="w-[22px] text-right text-[13px] font-semibold text-slate-400">{{ index + 1 }}</span>
        <span class="h-2.5 w-2.5 flex-none rounded-full" :style="{ backgroundColor: row.color }"></span>
        <span class="min-w-0 flex-1 truncate text-[15px] font-medium">{{ row.name }}</span>
        <div class="h-2 w-24 overflow-hidden rounded bg-edge sm:w-40">
          <div
            class="h-full rounded bg-blue-400 motion-safe:transition-[width] motion-safe:duration-700 motion-safe:ease-out"
            :style="{ width: grown ? row.width : '0%' }"
          ></div>
        </div>
        <span class="w-[34px] text-right text-sm font-semibold tabular-nums sm:text-[15px]">{{ row.value }}</span>
      </li>
    </ol>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Presence from '@/types/Presence';
import { percentOf } from '@/utils/format';
import { useGrow } from '@/composables/useGrow';

const props = defineProps<{ presences: Presence[]; meetings: number }>();

const rows = computed(() =>
  [...props.presences]
    .sort((a, b) => b.value - a.value)
    .map((p) => ({ ...p, width: percentOf(p.value, props.meetings) })),
);

const grown = useGrow(() => props.presences);
</script>
